import tripService from "../../../services/trip.service";
import {useEffect, useState} from "react";
import Checkbox from "../../../shared/checkbox/checkbox";
import {tripVehicleFilter} from "../../../store/slicers/tripsFilterSlicer";
import {useDispatch} from "react-redux";

const VehicleFilters = ({filter, dispatcher}) => {
    const [vehicles, setVehicles] = useState([]);
    const [searchedVehicles, setSearchedVehicles] = useState([]);
    const dispatch = useDispatch();

    const getVehicles = async () => {
        const allVehicles = await tripService.getVehicles();
        // get vehicles
        const vehicleList = allVehicles.data.vehicles.map((vehicle) => ({
            id: vehicle?._id,
            plateNo: vehicle.plateNo
        }));
        setVehicles(vehicleList);
        setSearchedVehicles(vehicleList);
    }
    const handleVehicleSelect = (val) => {
        dispatch(dispatcher(val));
    }
    const handleSearch = (e) => {
        const searchTxt = (e.target.value).toLowerCase().trim();
        // reset on empty
        if (!searchTxt) {
            setSearchedVehicles([...vehicles]);
        } else {
            const updatedVehicle = vehicles.filter((vehicle) =>
                (vehicle?.plateNo).toLowerCase().includes(searchTxt));
            setSearchedVehicles(updatedVehicle);
        }
    }

    useEffect(() => {
        getVehicles();
    }, [])

    return(
        <>
            <div className="filter-title margin-b-15">Vehicles</div>
            <div className="search-box margin-b-30 round-corner-8">
                <input type="text" placeholder={'Search'} onChange={handleSearch}/>
            </div>
            <ul className="filter-sec">
                {searchedVehicles.map((vehicle) =>
                   <li className={`page-fade-in`} key={vehicle?.id}>
                       <div  className="filter-box"
                            onClick={event => handleVehicleSelect(vehicle?.id)}>
                           <Checkbox checked={filter?.vehicles.includes(vehicle?.id)}/>
                           <div className={'filter-text'}>{vehicle?.plateNo}</div>
                       </div>
                   </li>
                )}
            </ul>

        </>
    )
}

export default VehicleFilters;
